/**
 * Copy text to the system clipboard. Uses the Async Clipboard API when it works,
 * and falls back to a hidden textarea + execCommand for environments where the API
 * is unavailable or blocked (e.g. HTTP on a LAN IP, or older browsers).
 */
export async function copyTextToClipboard(text) {
    const str = String(text ?? '');

    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(str);
            return;
        } catch {
            // Fall through — common when not in a secure context or permission denied
        }
    }

    const textarea = document.createElement('textarea');
    textarea.value = str;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, str.length);

    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);

    if (!ok) {
        throw new Error('Unable to copy to clipboard');
    }
}
